"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const tag_1 = __importDefault(require("components/cosmos/tag"));
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const translationContext_1 = require("configs/translationContext");
function getStyle(isMarked, isDefault) {
    if (isMarked) {
        return {
            variation: 'yellow',
            text: '_text-yellow-600'
        };
    }
    if (isDefault) {
        return {
            variation: 'blue',
            text: '_text-primary-600'
        };
    }
    return {
        variation: 'default',
        text: '_text-gray-900'
    };
}
const ClassTag = ({ name, tooltip, isMarked, isDefault = false }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const style = getStyle(isMarked, isDefault);
    return ((0, jsx_runtime_1.jsx)(tooltip_1.default, { content: isMarked ? tooltip : '', children: (0, jsx_runtime_1.jsxs)(tag_1.default, { variation: style.variation, className: "_text-1.5 _bg-transparent", children: [isMarked && ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'exclamation-triangle'], className: "_mr-1" })), (0, jsx_runtime_1.jsxs)("span", { className: (0, classnames_1.default)('_truncate-1 _text-wrap', style.text), children: [name, " ", isDefault && `(${t('general.default_class_label')})`] })] }) }));
};
exports.default = ClassTag;
